// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "62c7d1315dcb753d7f3a9d9d41311b20" + ".js";
};